var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoNotDisturbOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4202_29",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4202_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41683 11.9168H15.5835V10.0835H6.41683V11.9168ZM11.0002 20.1668C9.73211 20.1668 8.54044 19.9262 7.42516 19.445C6.30988 18.9637 5.33975 18.3106 4.51475 17.4856C3.68975 16.6606 3.03662 15.6904 2.55537 14.5752C2.07412 13.4599 1.8335 12.2682 1.8335 11.0002C1.8335 9.73211 2.07412 8.54044 2.55537 7.42516C3.03662 6.30988 3.68975 5.33975 4.51475 4.51475C5.33975 3.68975 6.30988 3.03662 7.42516 2.55537C8.54044 2.07412 9.73211 1.8335 11.0002 1.8335C12.2682 1.8335 13.4599 2.07412 14.5752 2.55537C15.6904 3.03662 16.6606 3.68975 17.4856 4.51475C18.3106 5.33975 18.9637 6.30988 19.445 7.42516C19.9262 8.54044 20.1668 9.73211 20.1668 11.0002C20.1668 12.2682 19.9262 13.4599 19.445 14.5752C18.9637 15.6904 18.3106 16.6606 17.4856 17.4856C16.6606 18.3106 15.6904 18.9637 14.5752 19.445C13.4599 19.9262 12.2682 20.1668 11.0002 20.1668Z",
    fill: "#C10606"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoNotDisturbOn);
export default __webpack_public_path__ + "static/media/do_not_disturb_on.23296201f97bffce9f3e33719e7a69de.svg";
export { ForwardRef as ReactComponent };